import { render, staticRenderFns } from "./NewPickupFromTemplate.vue?vue&type=template&id=06f67f7f&"
import script from "./NewPickupFromTemplate.vue?vue&type=script&lang=js&"
export * from "./NewPickupFromTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports